var _path, _path2, _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDritareDyKraheshe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 122,
    viewBox: "0 0 169 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9314 12.8411H13.5363V109.616H71.9314V12.8411ZM0.951172 0.161743V122H84.5165V0.161743H0.951172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.415 12.8411H98.0202V109.616H156.415V12.8411ZM85.4351 0.161743V122H169V0.161743H85.4351Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.3076,
    y: 13.7001,
    width: 56.8529,
    height: 95.6935,
    fill: "url(#paint0_linear_1018_39)",
    stroke: "#DEDEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.791,
    y: 13.7001,
    width: 56.8529,
    height: 95.6935,
    fill: "url(#paint1_linear_1018_39)",
    stroke: "#DEDEDE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.6079,
    y: 55.0493,
    width: 3.5915,
    height: 12.359,
    rx: 1.79575,
    stroke: "#DEDEDE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 98.2586,
    y2: -0.5,
    transform: "matrix(0.273021 -0.962008 0.91378 0.406209 99.9956 109.485)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 98.5609,
    y2: -0.5,
    transform: "matrix(0.283161 0.959072 -0.914568 0.404432 125.872 14.4784)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 71.1668,
    y2: -0.5,
    transform: "matrix(-0.758246 -0.651969 0.481206 -0.876608 154.337 108.706)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 72.5377,
    y2: -0.5,
    transform: "matrix(0.744014 -0.668164 0.497387 0.867529 99.9956 63.2795)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 71.0536,
    y2: -0.5,
    transform: "matrix(0.759445 -0.650571 0.490914 0.871208 15.4648 108.887)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 71.9112,
    y2: -0.5,
    transform: "matrix(-0.750453 -0.660924 0.501274 -0.865288 69.8062 62.3367)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1018_39",
    x1: 79.4318,
    y1: -92.331,
    x2: 33.8272,
    y2: 106.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1018_39",
    x1: 163.915,
    y1: -92.331,
    x2: 118.311,
    y2: 106.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDritareDyKraheshe);
export default __webpack_public_path__ + "static/media/dritare-dy-kraheshe.341e69504bf2649ae62ebb9b619e4df2.svg";
export { ForwardRef as ReactComponent };